module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('boxWrap', {
    attrs: {
      "name": _vm.name
    }
  }, [_c('div', {
    staticClass: "table"
  }, [_c('ul', {
    staticClass: "top"
  }, _vm._l((_vm.tablist), function(n, index) {
    return _c('li', [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == _vm.tab),
        expression: "index == tab"
      }]
    }, [_vm._v(_vm._s(n))])])
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "des"
  }, _vm._l((_vm.data), function(item) {
    return _c('li', [_c('p'), _vm._v(" "), _c('span', [_vm._v(_vm._s(item))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "bar6"
  }, [_c('div', {
    staticClass: "main"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a56e7032!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/yinxiao/components/item6/index.vue
// module id = 2069
// module chunks = 2